import { render, staticRenderFns } from "./LoaderComp.vue?vue&type=template&id=6add6b60&"
import script from "./LoaderComp.vue?vue&type=script&lang=js&"
export * from "./LoaderComp.vue?vue&type=script&lang=js&"
import style0 from "./LoaderComp.vue?vue&type=style&index=0&id=6add6b60&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports